import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { FiChevronRight } from 'react-icons/fi';

// Actions
import { updateQueryString } from '../../../../services/router/actions';

// Workspaces
import { selectNextDate } from '../../selectors';

// Styles
import './styles.scss';

interface Props {
    updateQueryString: Function;
    nextDate: string;
}

export class DatePaginationButtonRight extends React.Component<Props> {
    shouldComponentUpdate() {
        return false;
    }

    handelClick = () => {
        const { nextDate } = this.props;
        this.props.updateQueryString({
            date: nextDate,
            page: undefined
        });
    };

    render() {
        return (
            <button
                className="date-pagination-button-right"
                onClick={this.handelClick}
                type="button"
            >
                <FiChevronRight size="22" style={{ height: 30 }} />
            </button>
        );
    }
}
const mapStateToProps = createStructuredSelector({
    nextDate: selectNextDate
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(DatePaginationButtonRight);
